import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { LoginUser, MotesPaths } from '../models';

@Injectable({ providedIn: 'root' })
export class OidcLoginService {

    constructor(private http: HttpClient) {
    }

    /**
     * Convert a OIDC token into a custom Firebase login token (SCIM user with UID=OID of OIDC user)
     * @param idToken OIDC user id token
     * @returns LoginUser with custom token and user provider data from OIDC
     */
    public async getCustomOidcToken(idToken: string): Promise<LoginUser> {
        // Connect to server to verify token
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        });

        let rsp = await this.http.get<{ status: string, data: LoginUser; }>(MotesPaths.MOTES_API_OIDC_TOKEN, { headers: headers }).toPromise().catch((err) => {
            console.warn("Could not login in via OIDC", err);
            if((err?.error?.status as string)?.startsWith("No firebase user with the provided OID")) {
                err.code = "auth/no-oidc-user";
            }
            throw err;
        });

        if(!rsp) return null;
        return rsp.data;
    }
}
